import { all, fork } from "redux-saga/effects";
import chatSaga from "./Chat/chatsaga";
import contactSaga from "./Contact/contactsaga";

export default function* rootSaga() {
  yield all([fork(chatSaga),fork(contactSaga)]);
}
